/**
 * Fishermans — Seletor de bitolas do KIT (layout blocos).
 *
 * Raiz própria [data-fm-ks].
 *
 * MUDANÇA DE ARQUITETURA (14/09): o kit passou a ter PREÇO VARIÁVEL
 * (a partir de R$227 até R$263). Preço no Shopify vive na variante, então o
 * kit deixou de ser variante única + properties e virou 12 variantes reais
 * (4 bitolas S50 × 3 W98). Bônus: cada combinação ganhou SKU próprio, o que
 * tira o risco de expedição ter que ler texto livre.
 *
 * Por isso as caixas aqui NÃO inventam preço: elas PILOTAM os seletores
 * nativos do tema (disparando "change"), e quem recalcula o preço grande da
 * página é o próprio Shopify. Mesma técnica das caixas de bitola da v3.
 *
 * O que este script desenha por conta própria é só o RESUMO do kit — quanto
 * custa cada linha escolhida — porque isso o tema não sabe montar.
 */
(function () {
  "use strict";

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(".", ",");
    return "R$ " + v.replace(/\B(?=(\d{3})+(?!,))/g, ".");
  }

  document.querySelectorAll("[data-fm-ks]").forEach(function (root) {
    var dataEl = root.querySelector("[data-fm-ks-data]");
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!D || !D.linhas) return;

    var escopo = root.closest("product-info") ||
                 root.closest('[id^="shopify-section"]') ||
                 document;

    /*
     * Acha o <select> nativo da opção pelo atributo name — nunca por texto de
     * label: a página tem mais de um elemento rotulado com nomes parecidos.
     */
    function nativo(nomeOpcao) {
      try {
        return escopo.querySelector('select[name="options[' + nomeOpcao + ']"]');
      } catch (e) { return null; }
    }

    /* esconde os seletores nativos, mantendo-os no DOM (a lógica é deles) */
    Object.keys(D.linhas).forEach(function (chave) {
      var sel = nativo(D.linhas[chave].opcao);
      if (!sel) return;
      var caixa = sel.closest(".product-form__input") || sel;
      caixa.classList.add("fm-ks-hide-native");
    });

    var estado = {};

    function escolher(chave, valor) {
      var linha = D.linhas[chave];
      if (!linha) return;
      var v = linha.variantes.find(function (x) { return x.valor === valor; });
      if (!v) return;
      estado[chave] = v;

      root.querySelectorAll('[data-fm-ks-box="' + chave + '"]').forEach(function (b) {
        var on = b.getAttribute("data-fm-ks-valor") === valor;
        b.classList.toggle("is-selected", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });

      /* pilota o seletor do tema: é ele que troca a variante e o preço */
      var sel = nativo(linha.opcao);
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === valor) {
            if (sel.selectedIndex !== i) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event("change", { bubbles: true }));
            }
            break;
          }
        }
      }
      render();
    }

    function render() {
      Object.keys(D.linhas).forEach(function (chave) {
        var v = estado[chave];
        if (!v) return;
        var spec = root.querySelector('[data-fm-ks-spec="' + chave + '"]');
        var val = root.querySelector('[data-fm-ks-val="' + chave + '"]');
        if (spec) spec.textContent = v.valor;
        if (val) val.textContent = money(v.price);

        /*
         * Aqui vai SÓ a property escondida (chave com "_" na frente).
         * A bitola o cliente já lê na variante — "Bitola S50: 0.40mm" — e
         * repetir isso visível deixava o carrinho com 5 linhas de texto.
         * O que falta pra separação é o CÓDIGO, e esse o tema esconde:
         * property que começa com "_" não aparece no carrinho nem na
         * página do pedido, mas fica gravada no pedido e sai na API.
         */
        var prop = root.querySelector('[data-fm-ks-prop="' + chave + '"]');
        if (prop) {
          prop.value = v.valor + (v.sku ? " · " + v.sku : "");
        }
      });

      montarItens();
    }

    /*
     * O kit entra no carrinho como AS LINHAS REAIS — mesmo padrao do DUAS
     * AGUAS e do PESCADOR COMPLETO.
     *
     * Aqui o kit tem 12 variantes proprias (S50 x W98) e o preco e a SOMA das
     * duas linhas escolhidas. Por isso trocar a variante do kit pelas duas
     * linhas reais mantem o total igual — e a Bling passa a receber
     * MN043MMS50300M + MN037MMW98300M + AFP1 em vez de um SKU de kit que ela
     * nao sabe separar.
     *
     * So as properties que importam: "Kit" amarra as linhas; bitola e
     * metragem ja vem da propria variante, entao repetir poluia o carrinho.
     *
     * Inerte enquanto faltar escolha ou o produto de brinde: lista vazia faz
     * o fishermans-cart-guard cair no caminho antigo (a variante do kit).
     */
    function montarItens() {
      var destino = root.querySelector("[data-fm-kit-items]");
      if (!destino) return;

      var itens = [];
      var completo = true;

      Object.keys(D.linhas).forEach(function (chave) {
        var v = estado[chave];
        if (!v || !v.id) { completo = false; return; }
        itens.push({
          id: v.id,
          quantity: 1,
          properties: { "Kit": D.kitNome, "_KitHandle": D.kitHandle }
        });
      });

      if (!completo || !D.brindeGratisId) { destino.textContent = "[]"; return; }

      itens.push({
        id: D.brindeGratisId,
        quantity: 1,
        properties: {
          "Kit": D.kitNome,
          "Item do kit": "Brinde — " + (D.brindeNome || ""),
          "_KitHandle": D.kitHandle,
          "_Gratis": "1"
        }
      });

      destino.textContent = JSON.stringify(itens);
    }

    root.querySelectorAll("[data-fm-ks-box]").forEach(function (b) {
      b.addEventListener("click", function () {
        escolher(b.getAttribute("data-fm-ks-box"), b.getAttribute("data-fm-ks-valor"));
      });
      b.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          escolher(b.getAttribute("data-fm-ks-box"), b.getAttribute("data-fm-ks-valor"));
        }
      });
    });

    /* Estado inicial vem do Liquid (marcado no HTML), nunca só do JS. */
    Object.keys(D.linhas).forEach(function (chave) {
      var pre = root.querySelector('[data-fm-ks-box="' + chave + '"].is-selected');
      if (pre) escolher(chave, pre.getAttribute("data-fm-ks-valor"));
    });
  });
})();
